import { Slot } from 'expo-router'
import type { PropsWithChildren, ReactNode } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3'

import { env } from '@/src/config/env'
import { CaptchaV3Provider } from '@/src/general/hooks/useCaptcha'

export default function ContactLayout() {
  const captchaKey = env.EXPO_PUBLIC_CONF_KEY_GOOGLE_RECAPTCHA_V3

  // Warn if captcha key is missing
  if (!captchaKey && env.NODE_ENV === 'development') {
    console.warn(
      '[Captcha] Missing EXPO_PUBLIC_CONF_KEY_GOOGLE_RECAPTCHA_V3 environment variable. Captcha V3 will not work.',
    )
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={captchaKey || ''}>
      <CaptchaLayout>
        <Slot />
      </CaptchaLayout>
    </GoogleReCaptchaProvider>
  )
}

const CaptchaLayout = ({ children }: PropsWithChildren): ReactNode => {
  const { executeRecaptcha } = useGoogleReCaptcha()

  return (
    <CaptchaV3Provider executeRecaptchaV3={executeRecaptcha} CaptchaV2Component={ReCAPTCHA}>
      {children}
    </CaptchaV3Provider>
  )
}
